<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="mb-0">
      <template v-slot:prepend>
        <v-icon icon="mdi-home" size="small"></v-icon>
      </template>
    </v-breadcrumbs>

    <v-container class="grey lighten-5">
      <v-row>
        <v-col class="eventCalendar" cols="12" md="12">
          <EventCalendar />
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>

import EventCalendar from "@/components/shared/EventCalendar.vue";

export default {
  name: 'CalendarComponent',
  components: {
    EventCalendar
  },
  data: () => ({
    breadcrumbs: [
      {
        title: 'Dashboard',
        disabled: false,
        to: '/dashboard',
      },
      {
        title: 'Calender',
        disabled: true,
        to: '',
      },
    ],
  }),

  mounted() {
  },
  methods: {

  }
}
</script>